// extracted by mini-css-extract-plugin
module.exports = {"avatar":"_2HAG4","bordered":"_2KC1E","img":"_27odJ","defaultAvatar":"_3dE4N","xsmall":"GMnbN","small":"_1zS6i","medium":"g5JsK","large":"_1Vh00","xlarge":"dJYgV"};